<template>
  <div class="banner">
    <BaseBreadcrumb
      v-if="getBreadcrumb"
      class="container mt-4"
      :breadcrumb="getBreadcrumb"
    />
    <div class="banner__container">
      <p class="banner__title">
        {{ title }}
      </p>
      <img
        data-src="@images/public/policy/policy-dots.svg"
        width="107"
        height="118"
        class="lazyload  w-auto hidden lg:block -mt-4"
        alt="banner"
      >
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseBreadcrumb from '@design-system/base/breadcrumb/breadcrumb-pages'

export default {
  name: 'PrivacyPolicyBanner',
  components: { BaseBreadcrumb },
  props: {
    title: {
      type: String,
      default: ''
    },
    subtitle: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('global', ['getBreadcrumb'])
  }
}
</script>

<style scoped lang="scss">
.banner {
  @apply w-full bg-primary-50 rounded-br-large h-[105px] lg:h-[164px]
  flex flex-col ;
  &__container {
    @apply container flex justify-center lg:justify-between items-center my-6 lg:my-0;
  }
  &__title {
    @apply text-primary-700  text__headline-3-xs--bold
    lg:text__headline-3-md--bold;
  }
}
</style>
